var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "widget_holder" }, [
    _c("div", { staticClass: "widget_header" }, [
      _c("div", { staticClass: "widget_header_content" }, [
        _c("div", { staticClass: "widget_header_title" }, [
          _c("span", { class: _vm.widget.iconClass }),
          _vm._v(" "),
          _c("span", { staticClass: "heading_title" }, [
            _vm._v(_vm._s(_vm.tableTile))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "widget_header_right_content" },
          [_vm._t("headerContent")],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "widget_content" },
      [_vm._t("default"), _vm._v(" "), _c("div", { staticClass: "clearfix" })],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }